import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthenticationService } from '../_services';
import { environment } from '../../environments/environment';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService,
        private toastr: ToastrService,
        private router: Router) { }

        intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
            return next.handle(request).pipe(catchError(err => {
                if ([401, 403].includes(err.status)) {
                    const isRefreshRequest = request.url.includes('token/refresh');
                    const hasRefreshToken = !!this.authenticationService.currentUserValue?.refresh_token;

                    if (isRefreshRequest || !hasRefreshToken) {
                        localStorage.removeItem('currentUser');
                        localStorage.removeItem('offlineUser');
                        this.authenticationService.logout();

                        const error = err.error?.message || err.statusText;
                        return throwError(() => error);
                    }

                    if (!environment.production) {
                        console.log('Using refresh token');
                    }

                    this.authenticationService.refresh().subscribe({
                        next: (data) => {
                            if (!environment.production) {
                                console.log('Refresh token data: ', data);
                            }
                            localStorage.setItem('currentUser', JSON.stringify(data));
                            localStorage.setItem('offlineUser', JSON.stringify(data));
                            location.reload();
                        },
                        error: (error) => {
                            if (!environment.production) {
                                console.log('Error from refresh: ', error);

                            }
                            localStorage.removeItem('currentUser');
                            localStorage.removeItem('offlineUser');
                            this.authenticationService.logout();

                        }
                    });
                }
                const error = err.error?.message || err.statusText;
                return throwError(() => error);
            }))
        }


}
